
import { Header } from "@/components/layout/Header";
import { useState } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { DevelopmentalContent } from "@/components/goals/DevelopmentalContent";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Info } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { AgeGroup } from "@/types/developmental";
import { Card, CardContent } from "@/components/ui/card";

const GoalsAndOutcomes = () => {
  const [selectedAge, setSelectedAge] = useState<AgeGroup>(0);
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="container mx-auto px-4 py-8">
        <Button
          variant="ghost"
          onClick={() => navigate("/dashboard")}
          className="mb-4"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Dashboard
        </Button>

        <h1 className="text-3xl font-bold mb-6">Activities and Goals</h1>
        
        <Card className="mb-8">
          <CardContent className="p-6">
            <div className="flex items-start space-x-4">
              <Info className="w-6 h-6 text-blue-500 mt-1 flex-shrink-0" />
              <div>
                <p className="text-gray-600">
                  Discover key milestones and engaging activities tailored to each developmental category by age. Get expert-backed guidance to support your child's growth in motor, language, cognitive, independent, and social-emotional skills.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        <div className="w-full max-w-xs mb-6">
          <Select
            value={selectedAge.toString()}
            onValueChange={(value) => setSelectedAge(parseInt(value) as AgeGroup)}
          >
            <SelectTrigger className="w-full">
              <SelectValue placeholder="Select age" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="0">0-11 Months</SelectItem>
              {[1, 2, 3, 4, 5, 6].map((age) => (
                <SelectItem key={age} value={age.toString()}>
                  Age {age}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <DevelopmentalContent age={selectedAge} />
      </main>
    </div>
  );
};

export default GoalsAndOutcomes;
